<div class="pro-widget__title">
  <div class="pro-widget__title-text">{{ title() }}</div>
</div>
<div class="pro-widget__content" style="align-items: center; flex-grow: 1;">
  <app-sparkline [metricId]="metricId()" [displayType]="displayType()" [percentile]="percentile()"></app-sparkline>
  <div class="kpis">
    <app-kpi [subjectType]="SubjectType.institution" [value]="institutionKpiValue" [metricId]="metricId()" [displayType]="displayType()" label=""></app-kpi>
    @if (!percentile()) {
    <app-kpi [subjectType]="SubjectType.peer" [value]="peerKpiValue" [metricId]="metricId()" [displayType]="displayType()" label=""></app-kpi>
    }
  </div>
  <small class="widget-rec-range" [ngClass]="{ 'widget-rec-range--empty': !sortMessage() }" [innerHTML]="sortMessage()"></small>
</div>
<app-chart-info-box [information]="tooltip()"></app-chart-info-box>


